import React from 'react';
import { Button } from 'semantic-ui-react'

import SemanticUiModal from '../../components/modal';
import { getText } from '../../helpers';

function ArchiveActions(props) {
  return (
    <div>
      <Button positive fluid size='medium' className="archive-control-button" onClick={props.archiveLibraryControl}>
        {getText("Archive")}
      </Button>
    </div>
  )
}

export default function ConfirmArchiveLibraryControl(props) {
  const modalOptions = { className: "confirm-archive-control", size: "tiny" }
  return (
    <SemanticUiModal
      modalOptions={modalOptions}
      header={getText("Confirm Archive")}
      content={getText("Are you sure you want to archive this library control?")}
      actions={<ArchiveActions archiveLibraryControl={props.archiveLibraryControl}/>}
      closeModal={props.hideConfirmArchiveControl}
    />
  )
}



// WEBPACK FOOTER //
// ./src/views/control_library/confirm_archive_library_control.js